/**
 * Surface 1 v1 hand-curated synthetic holders — 5 holders representing
 * a believable mix of clinical contexts a state-Medicaid-Director
 * audience can recognize. Geography skews to states actively engaged
 * with SHN per PR #210 §4.1 state-by-state readiness narrative
 * (Maryland / Delaware / New Hampshire); organization mix covers
 * primary care, hospital, specialty pharmacy, reference lab, and
 * public-health agency so Surface 1's 5-min walkthrough demonstrates
 * the substrate's coverage across clinical-operations + public-health
 * + research + patient-rights authority frames per V1_AUTHORITY_FRAMES.
 *
 * **No real PHI at any point.** Names + geographies + organization
 * kinds are synthetic. Hand-curated for v1; v1.5+ migration target =
 * W6 `shn-synthetic` toolkit-generated per PR #210 §5.2.
 */
export const SYNTHETIC_HOLDERS = Object.freeze([
    {
        holderId: 'holder_atlantic_family_medicine',
        holderName: 'Atlantic Family Medicine',
        organizationKind: 'primary care clinic',
        geography: 'Annapolis, Maryland',
    },
    {
        holderId: 'holder_cape_henlopen_hospital',
        holderName: 'Cape Henlopen Hospital',
        organizationKind: 'hospital',
        geography: 'Lewes, Delaware',
    },
    {
        holderId: 'holder_granite_state_pharmacy',
        holderName: 'Granite State Specialty Pharmacy',
        organizationKind: 'specialty pharmacy',
        geography: 'Manchester, New Hampshire',
    },
    {
        holderId: 'holder_patapsco_lab',
        holderName: 'Patapsco Diagnostic Lab',
        organizationKind: 'reference lab',
        geography: 'Baltimore, Maryland',
    },
    {
        holderId: 'holder_delmarva_public_health',
        holderName: 'Delmarva Public Health Network',
        organizationKind: 'public-health agency',
        geography: 'Salisbury, Maryland',
    },
]);
//# sourceMappingURL=synthetic-holders.js.map